<ng-container [ngSwitch]="getComponentRenderState()">
  <ng-container *ngSwitchCase="'content'">
    <div class="redeem-cash-terms-information-container rounded-md">
      <div class="redeem-cash-terms-list-container">
        <ul class="redeem-cash-terms-list">
          <li class="redeem-cash-terms-list-item">
            <rd-shared-icon
              [iconSymbol]="'icon-convert-points'"
              [iconTheme]="'primary'"
              [iconOptions]="flippableIconOptions"></rd-shared-icon>
            <span class="redeem-cash-terms-list-item-text"
              >{{
                'app.points_with_points_currency'
                  | translate: loyaltyCurrencyTranslationParams()
              }}
              = {{ cashAmount() }}</span
            >
          </li>

          <li class="redeem-cash-terms-list-item">
            <rd-shared-icon
              [iconSymbol]="'icon-clock'"
              [iconTheme]="'primary'"></rd-shared-icon>
            <span class="redeem-cash-terms-list-item-text">{{
              'redeem_cash_v2.checkout.transfer_time'
                | translate: transferTimeParams()
            }}</span>
          </li>

          <li class="redeem-cash-terms-list-item">
            <rd-shared-icon
              [iconSymbol]="'icon-minimum-transfer'"
              [iconTheme]="'primary'"
              [iconOptions]="flippableIconOptions"></rd-shared-icon>
            <span class="redeem-cash-terms-list-item-text">{{
              'redeem_cash_v2.checkout.minimum_transfer'
                | translate: minimumPointsTransferTranslationParams()
            }}</span>
          </li>
        </ul>
      </div>
      <div
        *ngIf="checkoutReminderMessageKey"
        class="redeem-cash-terms-list-reminders-container">
        <p class="redeem-cash-terms-list-reminder">
          {{
            checkoutReminderMessageKey
              | translate: cashReminderTranslationParams()
          }}
        </p>
      </div>
    </div>
  </ng-container>
  <ng-container *ngSwitchCase="'loading'">
    <div class="redeem-cash-terms-information-container">
      <div class="redeem-cash-terms-list-container">
        <ul class="redeem-cash-terms-list">
          <li class="redeem-cash-terms-list-item loading"></li>
          <li class="redeem-cash-terms-list-item loading"></li>
          <li class="redeem-cash-terms-list-item loading"></li>
        </ul>
      </div>
      <div class="redeem-cash-terms-list-reminders-container">
        <p class="redeem-cash-terms-list-reminder loading"></p>
      </div>
    </div>
  </ng-container>
</ng-container>
